import React from 'react'
// import * as styled from "./Style"
// import { store } from '../../redux/store';
// import img from './logo.jpeg'
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { contentAfterLogin,afterLogout } from '../../redux/action-creator';
import "./Header.css"
// import {store} from "../../redux/store"
// import './index.css';
// import { Select } from 'antd';
import { useNavigate } from "react-router-dom"
// const { Option } = Select;

function Header(props) {
  
  const navigate = useNavigate()
  const logoutHandle=()=>{
    navigate("/")
    props.afterLogout()
  }
  const signInHandle=()=>{
    navigate("/signin")
  }

  function handleChange(value) {
    
    console.log(value.target.value,"++++ss+++++");
    if(value.target.value==="react"){
      navigate("/reactproject")
    }
    if(value.target.value==="ror"){
      navigate("/rorproject")

    }
    if(value.target.value==="hc"){
      navigate("/htmlcssproject")

    }
    if(value.target.value==="hcj"){
      navigate("/htmlcssjsproject")
  
    }
    if(value.target.value==="mern"){
      navigate("/mernproject")

    }
    if(value.target.value==="node"){
      navigate("/nodeproject")

    }
    if(value.target.value==="reared"){
      navigate("/reactreduxproject")

    }
     // { value: "lucy", key: "lucy", label: "Lucy (101)" }
  }
  const goToQuiz = () => {
    // store.getState().ourState.isQuiz=true;
  // console.log("++++  store.getState() +++++", store.getState())
    navigate("/login")
    
  }
  const goToHome = () => {
    navigate("/")

  }
  return (
    <>

    <div className="headerContainer">
      <nav className="navbar">
       <h1 className='navbar'>Concepts Matter</h1>
      </nav>
      <input type="checkbox" id="handle"/>
      <label htmlFor="handle" className='headeLabel'>
      <i class="fas fa-bars"></i>
      </label>
      <ul>
        <li onClick={goToHome}>
          Home
        </li>

        {
          props.adCa?
          (
          <><li> 
            <select className='headerSelect'
            labelInValue
            // defaultValue={{ value: 'hc' }}
            style={{ width: 120 ,border:"none"}}
            onChange={handleChange}>
              <option value="hc">HTML CSS</option>
              <option value="hcj">HTML CSS JS</option>
              <option value="react">React</option>
              <option value="reared">React-Redux</option>
              <option value="node">Node</option>
              <option value="mern">Mern</option>
              <option value="ror">ROR</option>
            </select>
            {/* <Select
        // disabled={true}
                labelInValue
                defaultValue={{ value: 'hc' }}
                style={{ width: 120 ,border:"none"}}
                onChange={handleChange}
              >
                <Option value="hc">HTML CSS</Option>
                <Option value="hcj">HTML CSS JS</Option>
                <Option value="react">React</Option>
                <Option value="reared">React Redux</Option>
                <Option value="node">Node JS</Option>

                <Option value="mern">Mern</Option>
                <Option value="ror">ROR</Option>





              </Select> */}
              </li>
              <li onClick={goToQuiz}>Mock Test</li></>):null
        }
        {
          !props.adCa?<li onClick={signInHandle}>Sign In</li>:<li onClick={logoutHandle}>Logout</li>
        }
              

      </ul>
    </div>
      {/* <styled.Container>
        <styled.Logo>
          <styled.LogoHeading >Concept Matter</styled.LogoHeading>
        </styled.Logo>
        <styled.Navbar>
          <styled.UnorderedList>
            <styled.List >
              Home
            </styled.List>


            <styled.List>
              <label htmlFor="" style={{marginRight:"10px"}}>Project</label>
              <Select
                labelInValue
                defaultValue={{ value: 'lucy' }}
                style={{ width: 120 }}
                onChange={handleChange}
              >
                <Option value="hc">HTML CSS</Option>
                <Option value="hcj">HTML CSS JS</Option>
                <Option value="react">React</Option>
                <Option value="reared">React Redux</Option>
                <Option value="mern">Mern</Option>
                <Option value="ror">ROR</Option>





              </Select>
            </styled.List>

            <styled.List onClick={goToQuiz}>
              Quiz
            </styled.List>


          </styled.UnorderedList>

        </styled.Navbar>
      </styled.Container> */}
    </>
  )
}
const mapStateToProps=(state)=>{
  return{
      adCa:state.ourState.showNav

  }
}
const mapDispatchToProps=(dispatch)=>{
  return{
  testFun:()=>dispatch(contentAfterLogin()),
  afterLogout:()=>dispatch(afterLogout())
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Header)

// export default Header
